<template>
  <qc-dialog class="tc-15-rich-dialog cos" type="custom" :show="innerShow" :title="'预览域名配置'" :default-cancel="false"
    @close="closeDialog" :width="550" :closeTriggers="['esc']">
    <ul class="item-descr-list allow-user-select">

      <li>
        <span class="item-descr-tit">
          <label>{{$t('cos.specified_domain')}}
            <qc-bubble type="dark" :append-to-body="false">
              <qc-icon type="plaint"></qc-icon>
              <template slot="popup">{{$t("cos.tips.specified_domain")}}</template>
            </qc-bubble>
          </label>
        </span>
        <span class="item-descr-txt">
          <qc-icon type="loading" v-if="!domain"></qc-icon>
          <domain-select v-else v-model="domain" :bucket="bucketInfo.Bucket" :region="bucketInfo.Region"
            :openWebsite="openWebsite" selectClass="dark-theme" />
        </span>
      </li>

      <li>
        <span class="item-descr-tit">
          <label>URL</label>
        </span>
        <span class="item-descr-txt">
          <qc-icon type="loading" v-if="!domain"></qc-icon>
          <qc-input type="textarea" v-else v-model="domain" :rows="3" :readonly="true"
            style="line-height:16px;background-color:unset;padding:8px;width:355px;"></qc-input>
        </span>
      </li>

      <li>
        <span class="item-descr-tit">
          <label>链接类型</label>
        </span>
        <span class="item-descr-txt">
          <qc-radio value="sign" v-model="type" class="mb-10">
            预览带签名
          </qc-radio>
          <qc-radio value="unSign" v-model="type">
            预览不带签名
          </qc-radio>
        </span>
      </li>

    </ul>

    <div slot="button">
      <div class="justify-grid">
        <div class="col"></div>
        <div class="col">
          <qc-button type="default" @click="onSubmit" :title="$t('core.ok')">
            {{$t('core.ok')}}</qc-button>
          <qc-button type="weak" @click="closeDialog" :title="$t('core.close')">{{$t('core.close')}}</qc-button>
        </div>
      </div>
    </div>

  </qc-dialog>
</template>

<script>
import { getInnerProps } from '@/scripts/tools/utils';
import storage from '@/scripts/tools/storage';
import cos from '@/scripts/helper/cos';
import cosExpand from '@/scripts/helper/cos/cosExpand';

import domainSelect from '@/components/common/domainSelect.vue';

export default {
  components: {
    domainSelect,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    bucketInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      domain: '',
      type: 'sign',
      openWebsite: false,
    };
  },
  computed: {
    innerShow: getInnerProps('show'),
    bucketInfoProxy: getInnerProps('bucketInfo'),
  },
  watch: {
    show(val) {
      if (val) {
        this.initData();
      } else {
        this.domain = '';
        this.type = 'sign';
      }
    },
  },
  methods: {
    initData() {
      const { bucketInfo } = this;
      const { Bucket, Region } = bucketInfo;
      cosExpand.getBucketPublicAcl(bucketInfo).then(ACL => {
        cos.getBucketWebsite(bucketInfo, (err, data) => {
          let Website = `${Bucket}.cos-website.${Region}.myqcloud.com`;
          if (err || data.statusCode === 404) {
            Website = '';
          } else {
            this.openWebsite = true;
          }

          if (ACL !== bucketInfo.ACL || Website !== bucketInfo.Website) {
            this.bucketInfoProxy = { ...bucketInfo, ACL, Website };
          }

          const domainSetting = storage.get('domainSetting');
          if (!domainSetting || domainSetting.bucket !== Bucket) {
            if (Website) {
              this.domain = Website;
            } else {
              this.domain = cos.getDefaultBucketDomain({ ...bucketInfo });
            }
            if (ACL.includes('public')) {
              this.type = 'unSign';
            }
          } else {
            this.domain = domainSetting.domain;
            this.type = domainSetting.type;
          }
        });
      });
    },
    onSubmit() {
      const { domain, type } = this;
      this.$emit('submit', { domain, type, bucket: this.bucketInfo.Bucket });
      this.closeDialog();
    },
    closeDialog() {
      this.innerShow = false;
    },
  },
};
</script>

<style scoped lang="scss">
.item-descr-list .item-descr-tit {
  vertical-align: middle;
}
</style>
